module.exports = __webpack_public_path__ + "static/media/bicc-about-us.e517e3f6.png";